// extracted by mini-css-extract-plugin
export default {"wrapper":"Prev_wrapper__wXEuB"};